export const FIREBASE_REFRESH_TOKEN='1//04Rulx-lpozBdCgYIARAAGAQSNwF-L9IrutSDEBTOgAyvpCZedCvbpNt57aOovMSvMlAEdi1emBxjoLoI1lLN87fb9t8X731Ht4s';
export const FIREBASE_CLIENT_ID='213005885431-5r149cjn9ndf11haq3vep3fpp4ivgcnl.apps.googleusercontent.com';
export const FIREBASE_CLIENT_SECRET='tQIFZmHbDqP0L9mGiDQt49Lr';
